import { PdRange } from "./pd-range/PdRange.js";
//#region src/pd-range/pd-range.ts
var tag = "pd-range";
if (!customElements.get(tag)) customElements.define(tag, PdRange);
//#endregion
export { PdRange };
